import React from 'react';
import { AdIcons } from './Ad';
import SienBanner from './SienBanner';
import BoothProduct from './BoothProduct';
import './ArticleSidebars.css';

export default function ArticleSidebars() {
  return (
    <>
      <div className="left-area article-ad-sidebar">
        <AdIcons />
      </div>
      <div className="right-area booth-product-sidebar">
        <SienBanner />
        <BoothProduct />
      </div>
    </>
  );
}
